import { isInternalPlan } from "../utils/pricingPlanUtils";
import { usePricingPlan } from "./usePricingPlan";

/** True for Free and Early Adopter — HTML bride-notification templates require a paid plan. */
export function useHtmlEmailLocked(): boolean {
  const { currentPlan } = usePricingPlan();
  return isInternalPlan(currentPlan.id);
}
